export default __webpack_public_path__ + "static/Scroll-Image---Concrete-Driveway-Removal-7b0def5ba57cee555eaae4cd93c19799.jpg";